module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAHOsAdPAAAABGdBTUEAALGPC/xhBQAAAQFJREFUKBWFkr1OgjEUhosGUIkD+DMRJWEwDiaujI5sJkxeAD+LM5M34KCJIwRG4+qt6AUY42bC5MIgic9TvhIhBt/kad9z2q/t6dcQVlRYideFRQc3oQUd2Nmg2YVrKDmizqABH9CEPHxCyMG2Bj1BCYxdJeqYtgcV6MIR/K8RU8oZ+iiXUZ7OfVXbjU6iDeGb/iLzpx79EF7AgTdQ5qKGtPWMgZm0pl7twRXUIOkd8wiTlEi99Y3BepWXcBPdvDGfqlqk73D7i2he2f2vWHsAt5p0pTO895/0hXHnPjxAFdRSOf4XCz535A+Z9xKct/wl8RZcgq/ABzOFV3jOPF0IPyIqHkkD/tNbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sj.png
// module id = w5Iq
// module chunks = 1